import React from 'react'

function FormTextarea({ value, placeholder, updateField, className, field }) {
  return (
    <textarea
      type="text"
      value={value}
      placeholder={placeholder}
      className={className}
      onChange={(e) => {
        e.preventDefault();
        updateField(field, e.target.value)
      }}
    />
  )
}

export default FormTextarea;